module.exports = function() {
  return new Worker(__webpack_public_path__ + "4549ddf30ae2548d07d7.worker.js");
};